import FileActions from "components/FileDownloadButtons";
import React from "react";
import { useTranslation } from "contexts/i18nContext";

interface EvidenceDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  evidence: any;
}

const EvidenceDetailModal: React.FC<EvidenceDetailModalProps> = ({
  isOpen,
  onClose,
  evidence,
}) => {
  const { t } = useTranslation();

  if (!isOpen || !evidence) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-xl mx-4 p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-gray-800">
            {t("evidenceDetails")}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-2xl"
          >
            &times;
          </button>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 gap-6">
          {/* Collected By */}
          <div className="">
            <p className="text-sm text-gray-500">{t("collectedBy")}</p>
            <p className=" font-medium text-gray-800">
              {evidence.collected_by}
            </p>
          </div>

          {/* Collected Date */}
          <div className="">
            <p className="text-sm text-gray-500">{t("collectedDate")}</p>
            <p className="font-medium text-gray-800">
              {evidence.collected_date}
            </p>
          </div>

          {/* Remarks */}
          {evidence.remark && (
            <div className=" ">
              <p className="text-sm text-gray-500">{t("remarks")}</p>
              <p className="font-medium text-gray-800">{evidence.remark}</p>
            </div>
          )}

          {/* Attachments */}
          {evidence.attachment_details?.length > 0 && (
            <div>
              <p className="text-sm font-semibold text-gray-700 mb-2">
                {t("evidenceFile")}
              </p>
              <ul className="space-y-3">
                {evidence.attachment_details.map((file: any) => (
                  <div
                    key={file?.document_dms_uuid}
                    className="flex justify-between items-center p-2 bg-gray-50 rounded-md"
                  >
                    <div className="flex items-center gap-2">
                      <div className="bg-[#5e3b1f] text-white font-bold text-xs px-2 py-1 rounded">
                        PDF
                      </div>
                      <div>
                        <p className="text-sm font-medium">
                          {file?.file_details?.file_name || t("evidenceInfo")}
                        </p>
                        {/* <p className="text-xs text-gray-500">11.3MB</p> */}
                      </div>
                    </div>

                    <FileActions fileUrl={file?.file_details?.url || ""} />
                  </div>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EvidenceDetailModal;
